<template>
  <v-container
    id="detalhe-clientes-sem-faturamento-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-col
              id="filtrosId"
              cols="12"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="2"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDia"
                        label="Data Inical"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDia"
                      no-title
                      @input="menu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  id="menu1"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Data Final"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ultimoDia"
                      no-title
                      @input="menu1 = false"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <v-select
                    v-model="select"
                    :items="empresa"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Empresas"
                    multiple
                    return-object
                  />
                </v-col>
                <v-col
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <v-select
                    v-model="vendedorSelect"
                    :items="vendedores"
                    item-value="id"
                    item-text="vendedor"
                    label="Vendedores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.vendedor }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.vendedor }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ vendedorSelect.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <v-select
                    v-model="supervisorSelect"
                    :items="supervisor"
                    item-value="id"
                    item-text="supervisor"
                    label="Supervisor"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.supervisor }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.supervisor }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ supervisorSelect.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  id="selectRedes"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="2"
                >
                  <v-select
                    v-model="redeSelect"
                    :items="redes"
                    item-value="id"
                    item-text="rede"
                    label="Redes"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.rede }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.rede }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ redeSelect.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="2"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDate()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Refazer
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row id="relatorioMelhoresClientesFaturados">
                        <v-col
                          id="relatorioMelhoresClientesFaturados"
                          cols="9"
                          class="text-left"
                        >
                          Quais meus clientes que não compraram no mês?
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-btn
                            id="btnPrint"
                            class="col-12 lg-12"
                            small
                            :disabled="enableBtn"
                            :color="corPrimaria"
                            dark
                            @click="imprimir()"
                          >
                            <v-icon>
                              mdi-printer
                            </v-icon>
                            Imprimir
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-tooltip top>
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationMelhoresClientes"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('335')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="codigo === '335'"
                              v-html="textoDetalhesClienteSemFat"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <div
                        v-if="loading"
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <div
                        v-else
                      >
                        <v-row
                          id="filtrosPrint"
                          class="hidden"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <h3 class="text-left">
                              Filtros Selecionados:
                            </h3>
                            <v-row>
                              <v-col
                                cols="3"
                              >
                                <div class="text-left">
                                  Data Inicial: {{ dataInicialImpressao }}
                                </div>
                                <div class="text-left">
                                  Data Final: {{ dataFinalImpressao }}
                                </div>
                              </v-col>
                              <v-col
                                v-if="select.length > 0"
                                cols="3"
                              >
                                <div
                                  class="'text-center'"
                                >
                                  Empresas selecionadas:
                                  <ul class="no-list-style">
                                    <li
                                      v-for="empresa in select"
                                      :key="empresa"
                                    >
                                      {{ empresa.nomeExibicao }}
                                    </li>
                                  </ul>
                                </div>
                              </v-col>
                              <v-col
                                v-if="vendedorSelect.length > 0"
                                cols="3"
                              >
                                <div
                                  class="'text-center'"
                                >
                                  Vendedores selecionados:
                                  <ul class="no-list-style">
                                    <li
                                      v-for="vendedor in vendedorSelect"
                                      :key="vendedor"
                                    >
                                      {{ vendedor.vendedor }}
                                    </li>
                                  </ul>
                                </div>
                              </v-col>
                              <v-col
                                v-if="redeSelect.length > 0"
                                cols="3"
                              >
                                <div
                                  class="'text-center'"
                                >
                                  Redes selecionadas:
                                  <ul class="no-list-style">
                                    <li
                                      v-for="rede in redeSelect"
                                      :key="rede"
                                    >
                                      {{ rede.rede }}
                                    </li>
                                  </ul>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <v-data-table
                              id="headersClientesFaturados"
                              :headers="headersDetalhamento"
                              :items="dadosDetalhamento"
                              :items-per-page="dadosDetalhamento.length"
                              fixed-header
                              disable-sort
                              hide-default-footer
                              class="elevation-1"
                              style="color: black"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Permissao from '../../../../../services/menu'
  import Cliente from '../../../../../services/somentecliente'

  export default {
    name: 'DashboardDetalhamentoClienteSemFaturamento',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaId')),
      empresa: [],
      vendedorSelect: JSON.parse(localStorage.getItem('vendedoresId')),
      vendedores: [],
      areaSelect: [],
      redeSelect: [],
      redes: [],
      supervisorSelect: JSON.parse(localStorage.getItem('supervisor')),
      supervisor: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClienteSemFat: '',
      headersDetalhamento: [
        { text: 'Rede', value: 'rede', width: '150px', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', width: '150px', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', width: '300px', align: 'left', class: 'black--text title' },
        { text: 'Dias sem Faturamento', value: 'dias', width: '150px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading: false,
      error: null,
      enableBtn: true,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoCliente'))

        Permissao.showEmpresas(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var i = 0

            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }

            for (i in resposta.data.vendedores) {
              this.vendedores.push(resposta.data.vendedores[i])
            }

            for (i in resposta.data.rede) {
              this.redes.push(resposta.data.rede[i])
            }

            for (i in resposta.data.supervisor) {
              this.supervisor.push(resposta.data.supervisor[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '335') {
            this.textoDetalhesClienteSemFat = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.formatarDatasImpressao()

        this.showDelhamentoClientesSemFaturamento()
      },

      imprimir () {
        window.print()
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      showDelhamentoClientesSemFaturamento () {
        this.loading = true
        this.enableBtn = true

        Cliente.showDelhamentoClientesSemFaturamento(this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, []).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosDetalhamento = resposta.data.dadosClientes.map((item) => {
              var listaDetalhamento = ({
                rede: item.rede,
                vendedor: item.vendedor,
                cliente: item.nome_cliente,
                dias: item.dias,
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.error = resposta.data.msg

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #relatorioMelhoresClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresClientes
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

  #btnPrint
    margin: 0 0 0 9rem

</style>

<style lang="sass">
  @media print
    #app-bar
      display: none !important

    #core-navigation-drawer
      display: none !important

    #filtrosId
      display: none !important

    #btnPrint
      display: none !important

    #iconInformationMelhoresClientes
      display: none !important

    .no-list-style
      list-style-type: none
      padding: 0
      margin: 0
      display: block

    .no-list-style li
      display: block
      text-decoration: none

    .hidden
      display: flex !important

    #relatorioMelhoresClientesFaturados
      margin: -7rem 0 0 -6rem

</style>
